//@flow
import {useSelector} from 'react-redux';
import {useActions} from '../../../utils/globalStore';

import {actions as countryActions} from '../duck';

import type {RootState} from '../../../modules';
import type {Country} from '../../../entities';
import {useEffect, useRef} from 'react';

const countrySelector = (state: RootState) => state.country.country;

export function useStoreCountry(): Country {
  const country = useSelector(countrySelector);

  return country;
}

const POLLING_MAX_COUNT = 4;

const countriesSelector = (state: RootState) => state.country.countries;

export function useCountries(): Country[] {
  const countries = useSelector(countriesSelector);
  const fetchCountries = useActions(countryActions.fetchCountries);
  const countRef = useRef(0);

  useEffect(() => {
    if (countRef.current >= POLLING_MAX_COUNT) return;
    if (countries) return;
    fetchCountries();
    countRef.current++;
  }, [countries, fetchCountries]);

  return countries || [];
}
